// 세션 인증 관련 유틸리티 함수들

// 랜덤 세션 키 생성 함수
export const generateSessionKey = () => {
  const timestamp = Date.now().toString();
  const randomString = Math.random().toString(36).substring(2, 15);
  const additionalRandom = Math.random().toString(36).substring(2, 15);
  return `${timestamp}_${randomString}_${additionalRandom}`;
};

// 세션 만료 시간 설정 (기본 2시간)
export const setSessionExpiry = (hours = 2) => {
  const expiryTime = Date.now() + (hours * 60 * 60 * 1000);
  sessionStorage.setItem('sessionExpiry', expiryTime.toString());
};

// 브라우저 핑거프린트 생성
export const generateBrowserFingerprint = () => {
  const fingerprint = navigator.userAgent + window.innerWidth + window.innerHeight;
  return btoa(fingerprint);
};

// 세션 검증 함수
export const validateSession = () => {
  const sessionKey = sessionStorage.getItem('adminSessionKey');
  const sessionExpiry = sessionStorage.getItem('sessionExpiry');
  const browserFingerprint = sessionStorage.getItem('browserFingerprint');
  const userRole = sessionStorage.getItem('userRole');
  
  // 세션 키가 없으면 인증 실패
  if (!sessionKey || !sessionExpiry || !browserFingerprint || userRole !== 'admin') {
    return false;
  }
  
  // 세션 만료 확인
  const currentTime = Date.now();
  if (currentTime > parseInt(sessionExpiry)) {
    clearSession();
    return false;
  }
  
  // 브라우저 핑거프린트 검증
  const currentFingerprint = navigator.userAgent + window.innerWidth + window.innerHeight;
  const storedFingerprint = atob(browserFingerprint);
  if (currentFingerprint !== storedFingerprint) {
    clearSession();
    return false;
  }
  
  return true;
};

// 세션 정리 함수
export const clearSession = () => {
  sessionStorage.removeItem('adminSessionKey');
  sessionStorage.removeItem('loginTime');
  sessionStorage.removeItem('userRole');
  sessionStorage.removeItem('sessionExpiry');
  sessionStorage.removeItem('browserFingerprint');
  // 기존 'id' 키도 제거 (하위 호환성)
  sessionStorage.removeItem('id');
};

// 세션 갱신 함수
export const refreshSession = (hours = 2) => {
  if (validateSession()) {
    const newExpiryTime = Date.now() + (hours * 60 * 60 * 1000);
    sessionStorage.setItem('sessionExpiry', newExpiryTime.toString());
    return true;
  }
  return false;
};

// 로그인 세션 설정
export const setLoginSession = () => {
  const sessionKey = generateSessionKey();
  const loginTime = Date.now().toString();
  const browserFingerprint = generateBrowserFingerprint();
  
  sessionStorage.setItem('adminSessionKey', sessionKey);
  sessionStorage.setItem('loginTime', loginTime);
  sessionStorage.setItem('userRole', 'admin');
  sessionStorage.setItem('browserFingerprint', browserFingerprint);
  setSessionExpiry();
  
  return sessionKey;
}; 